document.addEventListener('DOMContentLoaded', function () {
  var atcButton = document.querySelector('.quantity-submit-row');
  var stickyElement = document.getElementById('sticky-element');
  var add_to_cart_sticky = stickyElement.querySelector('.add-to-cart-sticky');
  var headerSticky = document.querySelector('.section-header');
  var productFormQuantity = document.querySelector('.buy-buttons-row');
  var extraMobileElement = document.getElementById('extra-mobile-element');

  function getStickyHeights() {
    var headerHeight = headerSticky ? headerSticky.offsetHeight : 0;
    var extraMargin = window.innerWidth <= 768 ? 0 : -45;
    return headerHeight + extraMargin;
  }

  function isElementInViewport(el, offset = 100) {
    if (!el) return false;
    var rect = el.getBoundingClientRect();
    return (
      rect.top < (window.innerHeight - offset) && 
      rect.bottom > offset
    );
  }

  function toggleStickyElement() {
    const offset = 130;
    const mediaGallery = document.querySelector('.media-gallery');
  
    if (window.innerWidth <= 768) { // Mobile
      if (
        isElementInViewport(atcButton, offset) ||
        isElementInViewport(productFormQuantity, offset) ||
        isElementInViewport(mediaGallery, offset)
      ) {
        stickyElement.style.display = 'none';
        stickyElement.classList.remove('sticky');
      } else {
        stickyElement.style.display = 'block';
        stickyElement.classList.add('sticky');
      }
    } else { // Desktop
      if (isElementInViewport(atcButton, offset)) {
        stickyElement.style.display = 'none';
        stickyElement.classList.remove('sticky');
      } else {
        stickyElement.style.display = 'block';
        stickyElement.classList.add('sticky');
      }
    }
  }
  
  

  function smoothScroll(event) {
    event.preventDefault();
    var targetId = this.getAttribute('href').substring(1);
    var targetElement = document.getElementById(targetId);
    var rect = targetElement.getBoundingClientRect();
    var scrollOffset = getStickyHeights(); // Adjust scroll offset based on sticky elements

    window.scrollTo({
      top: rect.top + window.scrollY - scrollOffset,
      behavior: 'smooth'
    });
  }

  window.addEventListener('scroll', toggleStickyElement);
  window.addEventListener('resize', toggleStickyElement);
  
  
  add_to_cart_sticky.addEventListener('click', function (event) {
    event.preventDefault();
  
    const behavior = add_to_cart_sticky.getAttribute('data-behavior');
  
    if (behavior === 'notify-me') {
      const notifyButton = atcButton.querySelector('#BIS_trigger');
      if (notifyButton) {
        notifyButton.click();
      }
    } else {
      const addBtn = atcButton.querySelector('.add-to-cart');
      if (addBtn) {
        addBtn.click();
      }
    }
  
    if (atcButton) {
      atcButton.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  });
  

  // Initial check
  toggleStickyElement();
});